<template>
  <div class="recurrence-form flex flex-col md:flex-row gap-3">
    <Card class="recurrence-option-chooser" headless>
      <RecurrencePresets v-model="presetName" :start-date="startDate" />
    </Card>
    <Card class="recurrence-details" headless>
      <RecurrenceDetails
        v-model="recurrenceRule"
        :start-date="startDate"
        :preset-name="presetName"
        :v$="v$"
      />
    </Card>
  </div>
</template>

<script setup lang="ts">
import { Moment } from "moment";
import { ref, watch } from "vue";

import Card from "@/components/Card.vue";
import RecurrenceDetails from "@/Scheduler/CalendarEventModal/forms/RecurrenceDetails.vue";
import { RecurrencePresetName, RecurrenceRule } from "@/typings/calendarEvent";
import { Validation } from "@vuelidate/core";
import RecurrencePresets from "./RecurrencePresets.vue";

const emit = defineEmits(["update:modelValue", "preset-changed"]);

const props = defineProps({
  modelValue: {
    type: Object as () => RecurrenceRule,
    required: true
  },
  preset: {
    type: String as () => RecurrencePresetName,
    required: true
  },
  startDate: {
    type: Object as () => Moment,
    required: true
  },
  v$: {
    type: Object as () => Validation,
    required: true
  }
});

const presetName = ref(props.preset);
watch(presetName, (newValue: RecurrencePresetName) => {
  emit("preset-changed", newValue);
});

const recurrenceRule = ref(props.modelValue);
watch(
  recurrenceRule,
  (newValue: RecurrenceRule) => {
    emit("update:modelValue", newValue);
  },
  { deep: true }
);
</script>

<style scoped lang="scss">
.recurrence-form {
  .recurrence-details {
    max-width: 442px;
    min-width: 380px;
  }
}
</style>
